import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Maintenance, MaintenanceType, MaintenanceStatus, Priority } from '../../models/maintenance';
import { ImmobilierService } from '../../services/immobilier.service';

@Component({
    selector: 'app-add-edit-maintenance-dialog',
    templateUrl: './add-edit-maintenance-dialog.component.html',
    styleUrls: ['./add-edit-maintenance-dialog.component.css']
})
export class AddEditMaintenanceDialogComponent implements OnInit {

    maintenance: Maintenance;
    isNew: boolean = true;
    properties: any[] = [];

    // Dropdown options
    maintenanceTypes: MaintenanceType[] = [
        'reparation', 'entretien', 'renovation', 'inspection', 'urgence', 'maintenance_preventive'
    ];

    maintenanceStatuses: MaintenanceStatus[] = [
        'demande', 'planifiee', 'en_cours', 'terminee', 'annulee', 'reportee', 'en_attente_fournisseur'
    ];

    priorities: Priority[] = ['basse', 'normale', 'haute', 'urgence'];

    categories: string[] = ['plomberie', 'electricite', 'chauffage', 'toiture', 'peinture', 'autre'];

    constructor(
        public dialogRef: MatDialogRef<AddEditMaintenanceDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private immobilierService: ImmobilierService,
        private snackBar: MatSnackBar
    ) {
        if (data && data.maintenance) {
            this.maintenance = { ...data.maintenance };
            this.isNew = false;
        } else {
            this.isNew = true;
            this.maintenance = {
                id: 0,
                reference: this.generateReference(),
                propertyId: 0,
                type: 'reparation',
                category: 'autre',
                title: '',
                description: '',
                requestDate: new Date(),
                status: 'demande',
                priority: 'normale',
                createdAt: new Date(),
                updatedAt: new Date()
            };
        }
    }

    ngOnInit(): void {
        this.loadProperties();
    }

    loadProperties(): void {
        this.immobilierService.getProperties().subscribe({
            next: (properties) => {
                this.properties = properties;
            }
        });
    }

    generateReference(): string {
        const date = new Date();
        const year = date.getFullYear();
        let random = Math.floor(Math.random() * 1000).toString();
        while (random.length < 3) {
            random = '0' + random;
        }
        return `MAINT-${year}-${random}`;
    }

    save(): void {
        // Update property info based on selection
        const selectedProperty = this.properties.find(p => p.id === this.maintenance.propertyId);
        if (selectedProperty) {
            this.maintenance.propertyReference = selectedProperty.reference;
            this.maintenance.propertyTitle = selectedProperty.title;
        }

        if (this.isNew) {
            this.immobilierService.createMaintenance(this.maintenance).subscribe({
                next: (res) => {
                    this.snackBar.open('Maintenance ajoutée avec succès', 'Fermer', { duration: 3000 });
                    this.dialogRef.close(res);
                },
                error: (err) => {
                    console.error(err);
                    this.snackBar.open('Erreur lors de l\'ajout', 'Fermer', { duration: 3000 });
                }
            });
        } else {
            this.immobilierService.updateMaintenance(this.maintenance.id, this.maintenance).subscribe({
                next: (res) => {
                    this.snackBar.open('Maintenance modifiée avec succès', 'Fermer', { duration: 3000 });
                    this.dialogRef.close(res);
                },
                error: (err) => {
                    console.error(err);
                    this.snackBar.open('Erreur lors de la modification', 'Fermer', { duration: 3000 });
                }
            });
        }
    }

    cancel(): void {
        this.dialogRef.close();
    }
}
